import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import { WithTabTitle } from '../../../../../common/widgets/withTabTitle';
import BenefitInfoPage from '../../../Pages/AdminAccount/EmployeeBenefits/BenefitInfoPage';
import EmployeeBenefitsPage from '../../../Pages/AdminAccount/EmployeeBenefits/EmployeeBenefitsPage';
import { resources } from '../../../resources/resources';

export const EmployeeBenefitsRoutes = () => {
  const { t: translate } = useTranslation();

  return (
    <Routes>
      <Route
        path=""
        element={
          <WithTabTitle title={translate(resources.menu.employeeBenefits)}>
            <EmployeeBenefitsPage />
          </WithTabTitle>
        }
      />

      <Route
        path=":orderId"
        element={
          <WithTabTitle title={translate(resources.menu.employeeBenefits)}>
            <BenefitInfoPage />
          </WithTabTitle>
        }
      />
    </Routes>
  );
};
